<script setup>
import { NAV_SHORTCUTS } from '@/composables/useKeyboardNav';
import Dialog from 'primevue/dialog';

const visible = defineModel('visible', { type: Boolean });

const shortcuts = Object.entries(NAV_SHORTCUTS).map(([key, { label }]) => ({
    keys: `g → ${key}`,
    label
}));
</script>

<template>
    <Dialog v-model:visible="visible" header="Keyboard Shortcuts" modal dismissableMask :style="{ width: '24rem' }">
        <div class="flex flex-col gap-2">
            <div class="flex items-center justify-between text-sm text-surface-500 dark:text-surface-400 mb-1">
                <span class="font-semibold uppercase text-xs">Navigation</span>
            </div>
            <div v-for="s in shortcuts" :key="s.keys" class="flex items-center justify-between py-1">
                <span>{{ s.label }}</span>
                <span class="flex gap-1">
                    <kbd
                        v-for="k in s.keys.split(' → ')"
                        :key="k"
                        class="px-2 py-0.5 rounded border text-xs font-mono bg-surface-100 dark:bg-surface-700 border-surface-300 dark:border-surface-600"
                    >{{ k }}</kbd>
                </span>
            </div>
            <div class="border-t border-surface-200 dark:border-surface-700 mt-2 pt-2">
                <div class="flex items-center justify-between py-1">
                    <span>Show this help</span>
                    <kbd class="px-2 py-0.5 rounded border text-xs font-mono bg-surface-100 dark:bg-surface-700 border-surface-300 dark:border-surface-600">?</kbd>
                </div>
            </div>
        </div>
    </Dialog>
</template>
